import { Reveal } from "./Reveal";
import { GraduationCap, BadgeCheck, CarFront } from "lucide-react";

const chapters = [
  {
    num: "01",
    icon: GraduationCap,
    title: "Formação TVDE",
    body: "Comporta a componente teórica de 44 horas de formação online, com horários flexíveis, e 6 horas de componente prática, presencial.",
  },
  {
    num: "02",
    icon: BadgeCheck,
    title: "Certificação CMTVDE",
    body: "Formação certificada reconhecida para obtenção do CMTVDE.",
  },
  {
    num: "03",
    icon: CarFront,
    title: "Ativação na Bolt",
    body: "Formação concluída, certificado em mão e todo o acompanhamento que precisas para te tornares motorista Bolt.",
  },
];

export default function Chapters() {
  return (
    <section id="programa" data-testid="chapters-section" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
      <Reveal>
        <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#34d186]">O Programa</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold tracking-tight text-[#171717] sm:text-3xl lg:text-4xl" data-testid="chapters-title">
          A formação necessária para iniciares a tua atividade como motorista Bolt.
        </h2>
        <p className="mt-5 max-w-2xl text-base text-[#737373] sm:text-lg">
          Para exercer a atividade de motorista TVDE é necessário frequentar, com aproveitamento, a formação
          adequada e obter a respetiva certificação profissional. O Grupo IFT acompanha-te em cada capítulo.
        </p>
      </Reveal>

      <div className="mt-16 space-y-0 border-t border-black/10">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.1}>
            <div
              data-testid={`chapter-${c.num}`}
              className="group grid grid-cols-1 gap-6 border-b border-black/10 py-10 transition-colors duration-500 hover:bg-black/[0.02] sm:grid-cols-12 sm:items-center sm:gap-8 sm:px-4"
            >
              <span className="font-mono-x text-sm text-[#34d186] sm:col-span-2 sm:text-base">/{c.num}</span>
              <div className="flex items-center gap-4 sm:col-span-4">
                <c.icon size={26} className="shrink-0 text-[#34d186]" />
                <h3 className="font-display text-xl font-bold text-[#171717] sm:text-2xl">{c.title}</h3>
              </div>
              <p className="text-sm leading-relaxed text-[#737373] sm:col-span-6 sm:text-base">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
